export class Cliente {
  documento: string;
  id: string;
  isunidade: string;
  nomeFantasia: string;
  checked: false;
  disabled: false;

  constructor(cliente) {
    this.documento = cliente['documento'] || null;
    this.id = cliente['id'] || null;
    this.isunidade = cliente['isunidade'] || null;
    this.nomeFantasia = cliente['nomefantasia'] || null;
  }

}
